import { Box, Button, Rating, Stack, Typography } from "@mui/material";
import CompaniesNavbar from "./CompaniesNavbar";
import StarIcon from "@mui/icons-material/Star";
import { useNavigate } from "react-router-dom";
import FooterSection from "../JobBoardHomepage/Footer/FooterSection";
import JoinPitchersDark from "./JoinPitchersDark";
import JobOpenIconCompaniesPage from "../../UI/JobOpenIconCompaniesPage";
const featuredCardsData = [
  {
    iconSrc: "/icons/moneyIcon.svg",
    iconSrcDarkMode: "/icons/employeeIconDarkModeUnActive.svg",
    text: "1339 employees",
  },
  {
    iconSrc: "/icons/moneyIcon.svg",
    iconSrcDarkMode: "/icons/moneyIconWhite.svg",
    text: "80,000 - 100,000 per year",
  },
  {
    iconSrc: "/icons/locationIconReviewsSection.svg",
    iconSrcDarkMode: "/icons/locationIconReviewsSectionWhite.svg",
    text: "Seattle, WA",
  },

  {
    iconSrc: "/icons/moneyIcon.svg",
    iconSrcDarkMode: "/icons/jobOpenIcon.svg",
    text: "8 jobs open",
  },
];
function CompaniesPage() {
  const navigate = useNavigate();
  return (
    <Stack sx={{ bgcolor: "#1c1c1c" }}>
      <CompaniesNavbar />

      <Stack
        direction="row"
        sx={{
          bgcolor: "#D9D9D9",
          py: "90px",
          px: "40px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h1" sx={{ fontSize: "50px", fontWeight: "700" }}>
          Discover Top Companies Hiring
        </Typography>
        {/* <Button
          sx={{
            fontSize: "16px",
            lineHeight: "22px",
            color: "#FFFFFF",
            py: "10px",
            textTransform: "none",
            bgcolor: "#1E1E1E",
            borderRadius: "10px",
            mt: "20px",
            px: "50px",
          }}
          onClick={() => navigate("/create-company")}
        >
          Create New Company
        </Button> */}
      </Stack>
      <Stack
        direction="row"
        sx={{ bgcolor: "#1c1c1c", p: "50px", justifyContent: "center" }}
      >
        <Stack
          id="card"
          sx={{
            // border: darkMode
            //   ? activeCompnay
            //     ? "none"
            //     : "1px solid #464646"
            //   : "1px solid #E4E4E4",
            p: "19.5px",
            px: "19px",
            borderRadius: "20px",
            minWidth: "420px",
            maxWidth: "420px",
            // bgcolor: arkMode
            //   ? activeCompnay
            //     ? "#000000"
            //     : "transparent"
            //   : activeCompnay
            //   ? "#000000"
            //   : "#ffffff",
            bgcolor: "#262626",
          }}
        >
          <Stack direction="row" sx={{ alignItems: "end", gap: "12px" }}>
            {" "}
            <Box
              component="img"
              src="/images/marketingGenius.jpg"
              sx={{
                width: "80px",
                height: "80px",
                objectFit: "cover",
                borderRadius: "10px",
                display: "block",
                flex: 0.6,
              }}
            ></Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "end",
                justifyContent: "space-between",
                flex: 2,
              }}
            >
              {" "}
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "700",
                  fontSize: "26px",
                  lineHeight: "30px",
                  fontFamily: "Inter",
                  // color: darkMode
                  //   ? "#ffffff"
                  //   : activeCompnay
                  //   ? "#ffffff"
                  //   : "#0E0B33",
                  width: "110px",
                  pb: "2px",
                  textAlign: "start",
                  color: "#ffffff",
                }}
              >
                TechWorks Incorporation
              </Typography>
              <Rating
                sx={{
                  pb: "6px",
                  color: "#FBCF5E", // Change the color of filled stars
                  "& .MuiRating-iconEmpty": {
                    color: "#c3c2cc", // Fully fill empty stars
                  },
                }}
                emptyIcon={
                  <StarIcon
                    style={
                      {
                        // color: darkMode
                        //   ? activeCompnay
                        //     ? "#ffffff"
                        //     : "#d3d3d3"
                        //   : activeCompnay
                        //   ? "#ffffff"
                        //   : "#c3c2cc",
                      }
                    }
                    fontSize="inherit"
                  />
                }
                name="size-small"
                defaultValue={2}
                size="small"
              />
            </Box>
          </Stack>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              // gap: "30px",
              pt: "4px",
              flexWrap: "wrap",
              justifyContent: "space-between",
              pt: "20px",
              gap: "4px",
            }}
          >
            {" "}
            {featuredCardsData.map((data, i) => (
              <Stack
                direction="row"
                sx={{
                  alignItems: "center",
                  gap: "6px",
                  pt: "0px",
                  justifyContent: "start",
                }}
              >
                <Box
                  component="img"
                  src={data.iconSrcDarkMode}
                  sx={{ width: "15px", height: "15px" }}
                ></Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "24px",
                    fontFamily: "Inter",
                    color: "#c9c9c9",
                    textAlign: "center",
                  }}
                >
                  {data.text}
                </Typography>
              </Stack>
            ))}
          </Box>
          <Button
            sx={{
              fontSize: "16px",
              lineHeight: "22px",
              color: "#FFFFFF",
              py: "10px",
              textTransform: "none",
              bgcolor: "#1E1E1E",
              borderRadius: "10px",
              mt: "20px",
            }}
          >
            See Details
          </Button>
        </Stack>
      </Stack>
      <JoinPitchersDark />
      <FooterSection />
    </Stack>
  );
}

export default CompaniesPage;
